import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { ProducerProvider } from "./context/ProducerContext";


const producerData = JSON.parse(localStorage.getItem("producerData")) || {};
const productData = JSON.parse(localStorage.getItem("productData")) || {};

const initialContext = {
  producer: producerData.producer || null,
  products: productData.products || [],
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter basename="/shoppingreact">
      <ProducerProvider value={initialContext}>
        <App />
      </ProducerProvider>
    </BrowserRouter>
  </React.StrictMode>
);// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
